import React from 'react';
import PropTypes from 'prop-types';
import CompanyLogoPlaceholder from '../../../../assets/images/boardtrac_plus_logo.svg';
import AzureMap from './AzureMap';
import Attendance from './AttendanceDropdown';
import './Meeting.css';
import store from '../../../../stores/store';
import * as utils from '../../../../helpers/utils';
import * as local from '../../../../helpers/localStorage';
import {
    MTG_MAP_LAT_DEFAULT,
    MTG_MAP_LONG_DEFAULT,
    MTG_VIEW_LIST,
    MTG_MAP_HEIGHT_LIST,
    MTG_MAP_HEIGHT_SINGLE,
    MTG_MAP_WIDTH,
    MTG_DRAFT,
    MTG_MAP_AZURE_KEY,
} from '../../../../helpers/constants';

import { observer } from 'mobx-react';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';

const MeetingCard = observer(
    class MeetingCard extends React.Component {
        constructor() {
            super();

            this.state = {
                mapWidth: 100,
                mapHeight: 100,
                pending1: false,
                pending2: false,
            };
        }

        componentDidMount() {
            this.setMapSize();
            window.addEventListener('resize', this.setMapSize, true);
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.setMapSize, true);
        }

        setMapSize = () => {
            const container = this.mapWrapper;
            const mapDimensions = container.getBoundingClientRect();

            this.setState({
                mapWidth: mapDimensions.width - 10,
                mapHeight: mapDimensions.height,
            });
        };

        onClick = e => {
            // Only come in here if they did not click on authorised
            if (e.target.className === '' || e.target.className === 'meeting-unread' || e.target.id === 'agenda-button') {
                let { details, viewType, selectMeeting, history } = this.props;
                if (viewType === MTG_VIEW_LIST) {
                    selectMeeting(details.InstanceId, details.GroupId, details.MeetingId, history);
                }
            }
        };

        onChange = () => {
            //
            this.forceUpdate();
        };

        selectGroup = () => {
            const index = store.companies.indexFromId(this.props.details.InstanceId);
            store.groups.toggleSelected(this.props.details.GroupId, index);
        };

        selectAuthorised = async AuthorisedId => {
            this.setState({
                pending1: true,
                pending2: true,
            });

            // If you select the same authorisation id then we switch it to zero which means in progress
            if (AuthorisedId === this.props.details.DraftStatus) {
                AuthorisedId = 0;
            }

            await store.meetings
                .responseAuthorisation(
                    Number(this.props.details.InstanceId),
                    Number(this.props.details.GroupId),
                    Number(this.props.details.MeetingId),
                    Number(AuthorisedId),
                )
                .then(json => {
                    this.setState({
                        pending1: false,
                        pending2: false,
                    });
                }).catch(err => {
                    this.setState({
                        pending1: false,
                        pending2: false,
                    });
                    console.log("Authorising error (meeting): ", err.spread.Message);
                });

            if (this.props.onChange) {
                this.props.onChange();
            }
        };

        changeState = async e => {
            // console.log('AttendanceDropdown changeState', this.props);
            await store.meetings.responseAttendendance(
                Number(this.props.instanceId),
                Number(this.props.groupId),
                Number(this.props.meetingId),
                Number(e),
            );
            if (this.props.onChange) this.props.onChange();
        };

        renderAuthorisation = () => {
            const { details } = this.props;

            /* var divStyle = {
                backgroundColor: 'var(--company-color)',
            }; */

            return (
                <tr>
                    <th scope="row">Approval:</th>
                    <td>
                        <div
                            className={'btn-group btn-group-sm btn-group-toggle'}
                            data-toggle="buttons"
                        >
                            {store.conn.isOnline ? (
                                <div
                                    className="btn-group btn-group-sm btn-group-toggle"
                                    data-toggle="buttons"
                                    id="Authorisation"
                                >
                                    <LaddaButton
                                        className={
                                            details.DraftStatus === '1'
                                                ? 'btn btn-outline-secondary active'
                                                : 'btn btn-outline-secondary'
                                        }
                                        aria-pressed="true"
                                        loading={this.state.pending1}
                                        onClick={() => this.selectAuthorised(1)}
                                        disabled={this.state.pending1}
                                        data-size={S}
                                        data-style={SLIDE_LEFT}
                                        data-spinner-size={30}
                                        data-spinner-color="#000"
                                        data-spinner-lines={12}
                                        id="lblAuthorised"
                                    >
                                        Authorised
                                    </LaddaButton>

                                    <LaddaButton
                                        className={
                                            details.DraftStatus === '2'
                                                ? 'btn btn-outline-secondary active'
                                                : 'btn btn-outline-secondary'
                                        }
                                        aria-pressed="true"
                                        loading={this.state.pending2}
                                        onClick={() => this.selectAuthorised(2)}
                                        disabled={this.state.pending2}
                                        data-size={S}
                                        data-style={SLIDE_LEFT}
                                        data-spinner-size={30}
                                        data-spinner-color="#000"
                                        data-spinner-lines={12}
                                        id="lblNotAuthorised"
                                    >
                                        Not authorised
                                    </LaddaButton>
                                </div>
                            ) : (
                                    <div className="mt-auto pt-2 pt-xl-0 pl-1">
                                        <button
                                            className="btn btn-sm btn-secondary disabled ml-auto"
                                            type="button"
                                        >
                                            <i className="fa fa-exclamation" aria-hidden="true" />
                                            <span className="pl-3" id="lblNotAuthorised">
                                                OFFLINE
                                        </span>
                                        </button>
                                    </div>
                                )}
                        </div>
                    </td>
                </tr>
            );
        };

        renderDetailsTable = () => {
            const { viewType, details } = this.props;

            const localMeeting = local.findMeetingFromLocalStorage(
                details.InstanceId,
                details.GroupId,
                details.MeetingId,
            );
            const localRead = localMeeting !== null ? localMeeting.read : false;

            return (
                <div className="d-flex flex-column align-items-start h-100">
                    <table
                        className={
                            viewType === MTG_VIEW_LIST
                                ? 'table table-sm table-borderless cursor-pointer'
                                : 'table table-sm table-borderless'
                        }
                        onClick={this.onClick}
                    >
                        <thead>
                            <tr>
                                <th colSpan="2">
                                    <h6 className={!localRead ? 'meeting-unread' : ''}>
                                        {details.MeetingName}
                                    </h6>
                                    <span className="doc-unread" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">My time:</th>
                                <td>{utils.getFormattedMeetingDateFromString(details.StartDateTime)} -- {utils.getFormattedMeetingDateFromString(details.EndDateTime)}</td>
                            </tr>
                            <tr className="date-row">
                                <th scope="row">Meeting Time:</th>
                                <td className="time-symbol">
                                    {utils.getFormattedMeetingLocalDatetime(
                                        details.StartDateTime,
                                        details.TimeOffset,
                                    )}&nbsp;
                                    {utils.getAbbreviatedZone(details.TimeZoneName)} -- {utils.getFormattedMeetingLocalDatetime(
                                        details.EndDateTime,
                                        details.TimeOffset,
                                    )}&nbsp;
                                    {utils.getAbbreviatedZone(details.TimeZoneName)}
                                </td>
                            </tr>
                            {details.Location !== '' ? (
                                <tr>
                                    <th scope="row">Room:</th>
                                    <td>{details.Location}</td>
                                </tr>
                            ) : null}
                            <tr>
                                <th scope="row">Address:</th>
                                <td>{details.Address}</td>
                            </tr>
                            <tr>
                                <th scope="row">Agenda:</th>
                                <td>{details.Agenda.length > 0 ? 'Attached' : 'Not attached'}</td>
                            </tr>
                            {store.meetings.filteredBy === MTG_DRAFT && details.LoginIsLead === 1
                                ? this.renderAuthorisation()
                                : null}
                        </tbody>
                    </table>
                <div className="meeting-buttons">
                    {store.conn.isOnline ? (
                        <div className="dropup mt-auto pt-2 pt-xl-0 button-left-margin">
                            <Attendance
                                meetingId={Number(details.MeetingId)}
                                groupId={Number(details.GroupId)}
                                attendance={Number(details.CurrentAttendance)}
                                instanceId={Number(details.InstanceId)}
                                key={'acceptance_' + details.MeetingId}
                                onChange={this.onChange}
                                meetingPanelRerender={this.props.meetingPanelRerender}
                            />
                        </div>
                    ) : (
                            <div className="mt-auto pt-2 pt-xl-0 pl-1">
                                <button
                                    className="btn btn-sm btn-secondary disabled ml-auto"
                                    type="button"
                                >
                                    <i className="fa fa-exclamation" aria-hidden="true" />
                                    <span className="pl-3">OFFLINE</span>
                                </button>
                            </div>
                        )}

                    {details.Agenda.length > 0 && viewType === MTG_VIEW_LIST ? (
                        <div className="dropup mt-auto pt-2 pt-xl-0">
                            <button
                                type="button"
                                id="agenda-button"
                                className="btn btn-outline-secondary agenda-button"
                                data-dismiss="modal"
                                onClick={this.onClick}
                            >
                                Agenda
                            </button>
                        </div>
                    ) : null}
                    </div>
                </div>
            );
        };

        render() {
            const { viewType, details, i, logo, agendaAnimations } = this.props;
            if (viewType === MTG_VIEW_LIST) {
                return (
                    <div className="col-12 mb-3">
                        <div className="card">
                            <div className="p-2">
                                <div className="row">
                                    <div className="col-sm-12 col-md-8 col-lg-5">
                                        {this.renderDetailsTable()}
                                    </div>
                                    <div
                                        className="hidden-sm-down col-md-4 col-lg-7 cartographer-container"
                                        key={i}
                                        ref={elem => (this.mapWrapper = elem)}
                                    >
                                        {details.Address.length !== 0 ? (
                                            <AzureMap
                                                latitude={
                                                    details.AddressLatitude || MTG_MAP_LAT_DEFAULT
                                                }
                                                longitude={
                                                    details.AddressLongitude || MTG_MAP_LONG_DEFAULT
                                                }
                                                address={details.Address}
                                                mapId={i}
                                                width={MTG_MAP_WIDTH}
                                                height={MTG_MAP_HEIGHT_LIST}
                                                 azureMapsKey={MTG_MAP_AZURE_KEY}
                                                 zoom={15}
                                            />
                                        ) : (
                                                <div className="no-location">
                                                    <i className="fa fa-map-marker fa-5x d-block" />
                                                    <br />Meeting location not specified
                                            </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="d-flex justify-content-start">
                                    <div className="footer-img text-center">
                                        <img
                                            className="my-auto mx-auto img-fluid"
                                            src={logo ? logo : CompanyLogoPlaceholder}
                                            alt="company logo"
                                            style={{ height: 18 }}
                                        />
                                    </div>
                                    <div
                                        className="small text-muted d-flex align-items-center cursor-pointer"
                                        onClick={() => this.selectGroup()}
                                    >
                                        {details.GroupName}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="pr-2 pb-2 pl-2">
                        <div className="row mt-2" id="meeting-details-top-content">
                            <a className="closebtn-meeting" onClick={() => agendaAnimations()}>
                                <i className="fa fa-times-thin fa-lg" aria-hidden="true" />
                            </a>
                            <div className="col-11 col-lg-6 pr-0">{this.renderDetailsTable()}</div>
                            <div
                                className="col-12 col-lg-6 pt-lg-3 mt-3 mt-lg-4 cartographer-container"
                                key={i}
                                ref={elem => (this.mapWrapper = elem)}
                            >
                                {details.Address.length !== 0 ? (
                                    <AzureMap
                                        latitude={details.AddressLatitude || MTG_MAP_LAT_DEFAULT}
                                        longitude={details.AddressLongitude || MTG_MAP_LONG_DEFAULT}
                                        address={details.Address}
                                        mapId={i}
                                        width={MTG_MAP_WIDTH}
                                        height={MTG_MAP_HEIGHT_SINGLE}
                                        azureMapsKey={MTG_MAP_AZURE_KEY}
                                        zoom={15}
                                    />
                                ) : (
                                        <div className="no-location">
                                            <i className="fa fa-map-marker fa-5x d-block" />
                                            <br />Meeting location not specified
                                    </div>
                                    )}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    },
);

MeetingCard.propTypes = {
    i: PropTypes.number.isRequired,
    details: PropTypes.object.isRequired,
    viewType: PropTypes.number.isRequired,
    logo: PropTypes.string,
    selectMeeting: PropTypes.func,
    // history: PropTypes.object,
    agendaAnimations: PropTypes.func,
};

export default MeetingCard;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/MeetingCard.js